(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.bundlePickerSaleTimer) return;
    window.bundlePickerSaleTimer = true;

    const pad = (value) => String(value).padStart(2, '0');

    const tick = () => {
      const now = Date.now() / 1000;
      document.querySelectorAll('[data-sale-ends]').forEach((banner) => {
        const ends = Date.parse(banner.dataset.saleEnds) / 1000;
        const left = Number.isNaN(ends) ? 0 : ends - now;
        const picker = banner.closest('.bundle-picker');

        if (left <= 0) {
          picker?.querySelectorAll('[data-sale-only]').forEach((node) => (node.hidden = true));
          picker?.querySelectorAll('[data-regular-only]').forEach((node) => (node.hidden = false));
          return;
        }

        const days = Math.floor(left / 86400);
        const hours = Math.floor((left % 86400) / 3600);
        const minutes = Math.floor((left % 3600) / 60);
        const seconds = Math.floor(left % 60);
        const countdown = banner.querySelector('[data-sale-countdown]');
        if (countdown) {
          countdown.textContent = `${days > 0 ? `${days}d ` : ''}${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
        }
      });
    };

    tick();
    setInterval(tick, 1000);
  })();
  } catch(e) { console.error(e); }
})();

})();
